import styled from 'styled-components'
import { Col } from 'components'

export const StyledInput = styled.input`
    &&& {
        border-radius: 2px;
        border: solid 1px #525966;
        color: #525966;
        box-sizing: border-box;
        display: inline-block;
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 0;
        height: 48px;
        padding: 0 10px;
        width: 100%;
        &::-ms-clear {
            display: none;
        }
        &:focus {
            box-shadow: none;
        }

        .input-error & {
            border-color: red;
        }
    }
`;

export const StyledLabel = styled.label`
  && {
    color: #323232;
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 16px;

    &:last-of-type {
      margin-bottom: 10px;
    }

    .input-error-message {
      color: red;
      font-size: 11px;
      font-weight: 500;
      margin-top: 3px;
    }
  }
`
export const Hint = styled.div`
  margin-top: 5px;
  color: gray;
  font-size: 12px;
  display: block;
  font-weight: 500;
`
export const FlexContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  height: 100%;
`
export const FieldsWrapper = styled.div`
  margin-bottom: 20px;
`
export const FlexItem = styled.div`
  overflow-y: auto;
  box-sizing: border-box;
  height: calc(100% - 106px);
`
export const FlexedItem = styled.div`
  overflow-y: auto;
  box-sizing: border-box;
  height: calc(100% - 91px);
`

export const Footer = styled.footer`
  padding: 10px;
  border-top: solid 1px lightgrey;
`



// WEBPACK FOOTER //
// ./src/components/FormElements/formStyles.js